import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static targets = ["search", "brokerage"]

    // Stimulus 2 has no keyboard event filters (`keyup.enter`), so the key is checked here.
    filterOnEnter(event) {
        if (event.key !== "Enter") return

        this.filter()
    }

    filter() {
        const filters = {
            query: this.searchTarget.value,
            // The brokerage select is only rendered when the admin can reach more than one.
            brokerage_id: this.hasBrokerageTarget ? this.brokerageTarget.value : ""
        }
        this.stimulate("UserReflex#filter", filters);
    }
}
